
<div *ngIf="entity.type === 'COMPANY'" class="panel">
  <h2>Liste des actionnaires</h2>

  <table *ngIf="entity.shareholders.items.length > 0">
    <thead>
      <tr>
        <th>Entité</th>
        <th>Solde</th>
        <th style="width: 50px;" *ngIf="canNavigate"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let share of entity.shareholders.items" (click)="showEntity(share)">
        <td name="Entité">{{ share.name }}</td>
        <td name="Solde">
          <span [ngClass]="{'error': negative(share.amount)}">
            {{ share.amount }}
          </span>

          <div class="item-details">
            <ng-container *ngFor="let detail of share.details">
              <div *ngIf="detail.amount.toString(10) !== '0'" [ngClass]="{'error': negative(detail.amount)}">
                <label>{{ detail.amount }}</label>
                <span>{{ detail.ownership }} {{ detail.shareType | slmovementlinesharetype:'short' }}</span>
              </div>
            </ng-container>
          </div>
        </td>
        <td style="width: 50px;" class="actions" *ngIf="canNavigate">
          <a class="action-btn">
            <t-icon name="arrow_forward"></t-icon>
          </a>
        </td>
      </tr>

      <!-- Total -->
      <tr>
        <td name="Total"><strong>Total</strong></td>
        <td name="Solde">
          <strong [ngClass]="{'error': negative(entity.shareholders.total)}">{{ entity.shareholders.total }}</strong>

          <div class="item-details">
            <ng-container *ngFor="let detail of entity.shareholders.details">
              <div *ngIf="detail.amount.toString(10) !== '0' || detail.invalid" [ngClass]="{'error': negative(detail.amount) || detail.invalid}">
                <label>{{ detail.amount }}</label>
                <span>{{ detail.ownership }} {{ detail.shareType | slmovementlinesharetype:'short' }}</span>
              </div>
            </ng-container>
          </div>
        </td>
        <td style="width: 50px;" class="actions" *ngIf="canNavigate">
        </td>
      </tr>

    </tbody>
  </table>

  <div class="empty-table compact" *ngIf="entity.shareholders.items.length === 0">
    <p>Aucun actionnaire dans cette entité</p>
  </div>

</div>